export const messages = {
    "Exit":"Сығыу",
    "Login":"Инеү",
    "Registration":"Теркәлеү",
    "Save":"Һаҡларға",
    "Administration":"Администраторлау",
    "Main":"Төп бит",
    "About":"Проект тураһында",
    "Social objects":"Социаль объекттар",
    "Employment":"Эшкә урынлашыу",
    "Events":"Ваҡиғалар",
    "Documents":"Документтар",
    "Monitorings, reports":"Мониторинг, отчет",
    "For parents":"Ата-әсәләр өсөн",
    "For specialists":"Специалистар өсөн",
    "Ask a question":"Һорау биреү",
    "Services":"Сервистар",
    "Language":"Тел",
    "English":"Башҡортса",
    "Сhoose the language":"Телде һайлау",
    "visually impaired":"насар күреүселәргә",
    "Navigator of Inclusive Education of the Republic of Bashkortostan":"Башҡортостан Республикаһының инклюзив белем биреү навигаторы",
    "Information portal":"Мәғлүмәт порталы",
    "Search":"Эҙләү",
    "Publication date":"Баҫманың датаһы",
    "Photo Collection":"Фотоһүрәттәр коллекцияһы",
    "Close":"Ябырға",
    "Events settings":"Ваҡиғаларҙы төҙәтеү",
    "Click to set up the event page":"Ваҡиғалар битен төҙәтеү өсөн баҫығыҙ",
    "Configure the event page":"Ваҡиғалар битен төҙәтегеҙ",
    "Author":"Автор",
    "Header":"Башланғыс",
    "Text":"Текст",
    "Link of the 1st photo":"1-се фотоға һылтанма",
    "Link of the 2nd photo":"2-се фотоға һылтанма",
    "Link of the 3rd photo":"3-сө фотоға һылтанма",
    "Link of the 4th photo":"4-се фотоға һылтанма",
    "Link of the 5th photo":"5-се фотоға һылтанма",
    "Link of the 6th photo":"6-сы фотоға һылтанма",
    "Link of the 7th photo":"7-се фотоға һылтанма",
    "Link of the 8th photo":"8-се фотоға һылтанма",
    "Link of the thumbnail":"Миниатюраға һылтанма",
    "Do you want to delete an event?":"Ваҡиғаны алып ташларға теләйһегеҙме?",
    "Do you want to delete a file?":"Файлды алып ташларға теләйһегеҙме?",
    "Do you want to delete a recommendation?":"Тәҡдимде алып ташларға теләйһегеҙме?",
    "Do you want to delete a question?":"Һорауҙы алып ташларға теләйһегеҙме?",
    "Do you want to delete a specialization?":"Һөнәрҙе алып ташларға теләйһегеҙме?",
    "Do you want to delete a organization?":"Ойошманы алып ташларға теләйһегеҙме?",
    "Authorization":"Инеү",
    "Password":"Пароль",
    "Log in":"Инергә",
    "Your name":"Һеҙҙең исемегеҙ",
    "Register as specialist":"Белгес булараҡ теркәлеү",
    "I agree with the privacy policy and consent to the processing of personal data":"Серлелек сәйәсәте менән ризамын һәм шәхси мәғлүмәттәрҙе эшкәртеүгә ризалыҡ бирәм",
    "Register":"Теркәлергә",
    "Questions to me":"Миңә һорауҙар",
    "My questions":"Минең һорауҙарым",
    "Question":"Һорау",
    "Answer":"Яуап",
    "Edit the answer":"Яуапты үҙгәртеү",
    "Comments":"Комментарийҙар",
    "Add comment":"Комментарий өҫтәргә",
    "Add answer":"Яуап өҫтәргә",
    "Cancel":"Кирегә ҡайтарыу",
    "Subject":"Тема",
    "Choose a specialist":"Белгесте һайлағыҙ",
    "Message":"Хәбәр",
    "Send":"Ебәреү",
    "For ask a question to specialists, please log in":"Белгестәргә һорау биреү өсөн системаға инегеҙ",
    "Please wait for the registration process to complete":"Теркәү процесын тамамлауҙы көтөгөҙ",
    "Select the specialist you want to ask a question":"Һорау бирергә теләгән белгесте һайлағыҙ",
    "Nothing found":"Бер ни ҙә табылманы",
    "Add a new specialization to the list":"Яңы һөнәрҙе исемлеккә өҫтәгеҙ",
    "Add a new disease to the list":"Яңы сирҙе исемлеккә өҫтәгеҙ",
    "Add a new organization to the list":"Яңы ойошманы исемлеккә өҫтәгеҙ",
    "Your full name":"Һеҙҙең тулы исемегеҙ",
    "Address":"Адрес",
    "Your insurance number of an individual personal account (СНИЛС)":"Һеҙҙең шәхси иҫәптең страховка номеры (СНИЛС)",
    "Your phone number":"Һеҙҙең телефон номеры",
    "Your child's date of birth":"Балағыҙҙың тыуған көнө",
    "Your child's gender":"Һеҙҙең балағыҙҙың енесе",
    "Select a specialty":"Һөнәрегеҙҙе һайлағыҙ",
    "Select an organization":"Ойошмағыҙҙы һайлағыҙ",
    "Select a disease":"Ауырыуҙы һайлағыҙ",
    "The category of your child with disabilities":"Балағыҙҙың һаулыҡ мөмкинлектәре сикле категорияһы",
    "What grade does your child study in?":"Һеҙҙең балағыҙ нисәнсе синыфта уҡый?",
    "There is no answer yet":"Яуап юҡ әле",
    "There is no comment yet":"Әлегә комментарийҙар юҡ",
    "Your email":"Һеҙҙең email",
    "Information":"Мәғлүмәт",
    "Forgot your password?":"Паролде оноттоғыҙмы?",
    "Reset Password":"Пароль ташлау",
    "New password":"Яңы пароль",
    "Documents settings":"Документтарҙы төҙәтеү",
    "Click to set up documents":"Документтарҙы төҙәтеү өсөн баҫығыҙ",
    "Date":"Дата",
    "Chapter":"Бүлек",
    "Publisher":"Нәшер итеүсе",
    "Status":"Статус",
    "Type":"Тип",
    "Grade":"Категория",
    "Name":"Исеме",
    "File":"Файл",
    "Setting up documents":"Документтарҙы төҙәтеү",
    "Recommendations of specialists":"Белгестәрҙән кәңәштәр",
    "Recommendations for specialists":"Белгестәр өсөн кәңәштәр",
    "Working with files":"Файлдар менән эшләү",
    "Click to add/remove files":"Файлдарҙы өҫтәр/алып ташлар өсөн баҫығыҙ",
    "Recommendations":"Тәҡдимдәр",
    "Click to edit recommendations":"Тәҡдимдәрҙе төҙәтер өсөн баҫығыҙ",
    "My recommendations":"Минең тәҡдимдәрем",
    "Add recommendation":"Тәҡдимдәр өҫтәү",
    "Title":"Башланғыс",
    "Recommendation":"Тәҡдим",
    "Setting up recommendations":"Кәңәшмәләрҙе төҙәтеү",
    "Add a new chapter":"Яңы бүлек өҫтәгеҙ",
    "Add a new publisher":"Яңы нәшер итеүсене өҫтәгеҙ",
    "Add a new status":"Яңы статус өҫтәгеҙ",
    "My files":"Минең файлдарым",
    "LE Registration":"Регистрация ЮЛ",
    "LE Authorization":"Авторизация ЮЛ",
    "District/City":"Район/Ҡала",
    "Log in to the IS Monitoring":"ИС Мониторингҡа инеү",
    "Literature":"Әҙәбиәт",
    "Materials":"Материалдар",
    "List of users":"Файҙаланыусылар исемлеге",
    "Click to work with users":"Файҙаланыусылар менән эшләү өсөн баҫығыҙ",
    "List of specialists":"Специалистар исемлеге",
    "Click to see the specialists":"Специалистарҙы ҡарау өсөн баҫығыҙ",
    "List of organizations":"Ойошмалар исемлеге",
    "Click to see the organizations":"Ойошмаларҙы ҡарау өсөн баҫығыҙ",
    "List of specializations":"Һөнәрҙәр исемлеге",
    "Click to see the specializations":"Һөнәрҙәрҙе ҡарау өсөн баҫығыҙ",
    "Activity of specialists":"Белгестәрҙең әүҙемлеге",
    "Click to see the activity of specialists":"Белгестәрҙең әүҙемлеген тикшерер өсөн баҫығыҙ",
    "Ministry of Education of the Russian Federation":"РФ Мәғариф министрлығы",
    "Institute of Correctional Pedagogy  of the":"Рәсәй мәғариф академияһының Коррекция педагогикаһы институты",
    "Ministry of Education and Science of the RB":"БР Мәғариф һәм фән министрлығы",
    "Ministry of Education of the RB":"БР Мәғариф министрлығы",
    "Institute of Education Development of the RB":"БР Мәғарифты үҫтереү институты",
    "Official Internet portal of legal information":"Рәсми хоҡуҡи мәғлүмәт интернет-порталы",
    "Delete":"Юйырға",
    "All questions":"Бөтә һорауҙар",
    "Click to see the all questions":"Бөтә һорауҙарҙы ҡарау өсөн баҫығыҙ",
    "Feedback":"Баһа",
    "To feedback, please log in.":"Баһа биреү өсөн системаға инегеҙ.",
    "Feedbacks":"Баһалар",
    "Click to see the all feedbacks":"Бөтә баһаларҙы ҡарау өсөн баҫығыҙ",
    "Distance Education Teacher":"Дистанцион белем биреү уҡытыусыһы",
    "Nosologies":"Нозологиялар",
    "Current password":"Иҫке пароль",
    "Change the password":"Паролде үҙгәртеү",
    "Save the password":"Паролде һаҡларға",
    "Proud of you, our graduate!":"Ғорурланам һинең менән, уҡыусым!",
    "Back":"Ҡайтарыу",
    "Graduate":"Уҡыусы",
    "School":"Мәктәп",
    "Municipality":"Муниципаль яһалма",
    "Viewed":"Ҡаралған",
    "Video":"Видео",
    "Click to add videos for the page 'Proud of you, our graduate!'":"'Ғорурланам һинең менән, уҡыусым!' битенә видео өҫтәр өсөн баҫығыҙ",
    "Moderate videos":"Видеоларҙы тикшереү",
    "Click to see the all videos and moderate them":"Бөтә видеоларҙы күреү һәм тикшереү өсөн баҫығыҙ",
    "Full name of the graduate":"Уҡыусының тулы исеме",
    "Name of school":"Мәктәп исеме",
    "Graduation year":"Уҡып бөткән йылы",
    "Code for embedding video":"Видеоны ҡуйыу коды",
    "Configure the video page":"Видео әҙерләү бите",
    "The video is not moderated":"Видео тикшерелмәгән",
    "Approve":"Әҙер",
    "Remove from approval":"Әҙер түгел",
    "Do you want to delete a video?":"Видеоны алып ташлағығыҙ киләме?",
    "Professional testing":"Профессиональ тест",
    "Career guidance":"Профессияларға йүнәлеш биреү",
    "Atlas of professions":"Профессиялар атласы",
    "Answer-Question":"Һорау-Яуап",
    "New ones first":"Яңылары алдан",
    "Old ones first":"Иҫкеләре алдан",
    "Schools for teaching children with ASD in the Republic":"Башҡортостан республикаһында аутизм спектры боҙолоуы булған балаларҙы уҡытыу буйынса терәк мәктәптәр",
    "Organizations that help children with":"Аутизм спектры боҙолоуы менән сирләгән балаларға ярҙам күрһәтеүсе ойошмалар",
    "Education for Children with ASD":"Аутизмлы балаларҙы уҡытыу",
    "Interactive Map of Social Facilities":"Социаль объекттарҙың интерактив картаһы",
    "Educational Facilities":"Белем биреү объекттары",
    "Employment Centers and Organizations Providing Rehabilitation Services":"Мәшғүллек үҙәктәре, реабилитация хеҙмәттәре күрһәтеүсе ойошмалар",
    "Healthcare Facilities":"Һаулыҡ һаҡлау объекттары",
    "Regional Personnel Registry":"Регионал персонал реестры",
    "Specialists in psychological and pedagogical support for students with disabilities":"Мөмкинлектәре сикләнгән уҡыусыларға психологик-педагогик ярҙам күрһәтеү буйынса белгестәр",

    // Организации родителей / фонды
    "ANO \"RASSVET\"":"АНО «РАССВЕТ»",
    "MAOU \"City Center ProDobro\", Ufa":"МАОУ «Городской үҙәк «ПроДОбро» Өфө",
    "Regional parents’ organization of children with disabilities of the RB":"Инвалиды булған балаларҙың ата-әсәләренең төбәк йәмәғәт ойошмаһы (БР)",
    "ANO \"Clear Mind\" (adaptive & inclusive programs for people with ASD)":"АНО «Таңса аҡыл» (адаптив һәм инклюзив программалар)",
    "Council of Mothers \"Materinskoe Serdce\" of the RB":"Әсәләр советы «Әсә йөрәге» БР",
    "Charitable Educational Foundation \"Markhamat\"":"Хәйриә белем биреү фонды «Мархамат»",

    // Центры ментального здоровья
    "Mental Health Center (RCPPMCP) — Ufa":"Психик һаулыҡ үҙәге (РЦППМСП) — Өфө",
    "Mental Health Center (RCPB)":"Психик һаулыҡ үҙәге (РКПБ)",
    "Mental Health Center — FRC TMNR":"Психик һаулыҡ үҙәге — ФРЦ ТМНР",
    "Mental Health Center — FCIO":"Психик һаулыҡ үҙәге — ФЦИО",
    "Mental Health Center — FRC ASD":"Психик һаулыҡ үҙәге — ФРЦ РАС",
}
